import * as React from 'react';
import { useQuery as useQuery$1 } from '@apollo/client';
import { handleError } from './helpers.js';

const useQuery = (query, options)=>{
    const result = useQuery$1(query, options);
    const { error  } = result;
    React.useEffect(()=>{
        if (error) {
            handleError(query, error);
        }
    }, [
        error,
        query
    ]);
    return result;
};

export { useQuery as default };
//# sourceMappingURL=use-query.js.map
